import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const useFetchHubspot = () => {
  const { post } = useFetchWithDefaults()
  const { activeWorkspaceId } = useAuth()

  const sendContactRequest = ({ payload }:
  { payload: App.Data.Payloads.HubSpot.HubSpotContactFormPayload }) => post<void>({
    url: '/v2/hubspot/contact-request',
    fetchOptions: {
      body: payload,
    },
    workspaceId: activeWorkspaceId.value ?? undefined,
  })

  const sendCancellation = ({ payload }:
  { payload: App.Data.Payloads.HubSpot.HubSpotCancelFormPayload }) => post<void>({
    url: '/v2/hubspot/cancellation',
    fetchOptions: {
      body: payload,
    },
    workspaceId: activeWorkspaceId.value ?? undefined,
  })

  const sendTemplateRequest = ({ payload }:
  { payload: App.Data.Payloads.HubSpot.HubSpotTemplateRequestPayload }) => post<void>({
    url: '/v2/hubspot/template-request',
    fetchOptions: {
      body: payload,
    },
    workspaceId: activeWorkspaceId.value ?? undefined,
  })

  return {
    sendContactRequest,
    sendCancellation,
    sendTemplateRequest,
  }
}
